import '@ambulnz/amb-header';
import { Drawer, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { drawerWidth, theme, toolbarHeight } from '../../theme';
import MapWidget from '../MapWidget';
import Timeline from '../Timeline';
import Eligibility from '../Eligibility';
import AmbHeaderWrapper from './Header/AmbHeaderWrapper';

const AppFrame = props => {
  const isSmallScreen = useMediaQuery('(max-width:960px)');
  const isInteractionLocked = !!props.isInteractionLocked;

  return (
    <div
      style={{
        width: '100%',
        zIndex: 1,
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        top: window.ambulnzConfig.isAnExternalApp ? 0 : toolbarHeight,
      }}
    >
      {window.ambulnzConfig.isAnExternalApp ? null : (
        <div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 100 }}>
          <AmbHeaderWrapper
            onPreferredSelected={props.selectPreferredFacility}
            onAllPreferredUnset={() => props.selectPreferredFacility()}
            phone={props.phone}
            theme={window.ambulnzConfig.constants.HEADER_THEME}
            user={JSON.stringify({
              ...props.user,
              isUserAmbAdmin: props.isUserAmbAdmin,
              preferredFacility: props.preferredFacility,
            })}
            navbar-enabled={window.ambulnzConfig.navbarEnabled}
            mobile-health-enabled={window.ambulnzConfig.constants.MOBILE_HEALTH_SERVICE_ENABLED}
            metrics-enabled={window.ambulnzConfig.constants.METRICS_DASHBOARD_ENABLED}
            help-center-url={window.ambulnzConfig.constants.DARA_HELP_CENTER_URL}
            release-notes-url={window.ambulnzConfig.constants.DARA_RELEASE_NOTES_URL}
          />
        </div>
      )}
      <div style={{ display: 'flex', width: '100%', height: '100%' }}>
        <Drawer
          variant="permanent"
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
              position: isSmallScreen ? 'fixed' : 'static',
              top: isSmallScreen ? 0 : toolbarHeight,
              left: 0,
            },
          }}
        >
          <div
            aria-disabled={isInteractionLocked}
            inert={isInteractionLocked ? '' : undefined}
            style={{
              pointerEvents: isInteractionLocked ? 'none' : 'auto',
              opacity: isInteractionLocked ? 0.6 : 1,
              height: '100%',
            }}
          >
            {props.children}
          </div>
        </Drawer>
        <div style={{ backgroundColor: theme.palette.background.default, width: '100%' }}>
          <Timeline />
          <MapWidget />
          <Eligibility />
        </div>
      </div>
    </div>
  );
};

AppFrame.propTypes = {
  phone: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  isInteractionLocked: PropTypes.bool,
};

const mapStateToProps = state => ({
  isInteractionLocked:
    !!state.eligibility?.changesModal?.pendingReview || !!state.eligibility?.agentView?.pendingReview,
});

export default connect(mapStateToProps)(AppFrame);
